import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SignalTranslationEquation from './SignalTranslationEquation';
import { getSignalTranslationEquation, getUserProfileWidget } from '../../selectors/index';
import {
  saveSignalTranslationEquationThunk,
  describeSignalTranslationEquationThunk,
  setSignalTranslationEquationChangeThunk,
  setSignalTranslationEquationCleanUpThunk,
  setSignalTranslationEquationConstantThunk,
  setSignalTranslationEquationConstantListThunk,
  showAddEditSreenThunk,
  setSignalTranslationEquationCustomErrorThunk
} from '../../actions/signalTranslationEquation';

const mapStateToProps = state => {
  return {
    signalTranslationEquationManager: getSignalTranslationEquation(state),
    userProfileWidgets: getUserProfileWidget(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveSignalTranslationEquation: (signalTranslationEquation, widgetCode) => saveSignalTranslationEquationThunk(signalTranslationEquation, widgetCode),
      describeSignalTranslationEquation: (signalTranslationEquationId, modelCategoryId) =>
        describeSignalTranslationEquationThunk(signalTranslationEquationId, 'SIGNALTRANSLATIONEQUATIONEDIT', modelCategoryId),
      changeSignalTranslationEquation: selectedSignalTranslationEquation => setSignalTranslationEquationChangeThunk(selectedSignalTranslationEquation),
      cleanUpSignalTranslationEquation: () => setSignalTranslationEquationCleanUpThunk(),
      setSignalTranslationEquationCustomError: (messageCode, status) => setSignalTranslationEquationCustomErrorThunk(messageCode, status),
      changeSignalTranslationEquationConstant: selectedSignalTranslationEquationConstant =>
        setSignalTranslationEquationConstantThunk(selectedSignalTranslationEquationConstant),
      setSignalTranslationEquationConstantList: signalTranslationConstantList => setSignalTranslationEquationConstantListThunk(signalTranslationConstantList),

      showAddEditScreen: status => showAddEditSreenThunk(status)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignalTranslationEquation);
